import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import config from '@app/utils/config/endpoints';

// Get connection string from AppConfig
const connectionString = config.telemetryConnectionString;

// Create and configure Application Insights instance
let appInsights: ApplicationInsights | null = null;

if (connectionString) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: connectionString,
      enableAutoRouteTracking: true, // Automatically track route changes in React Router
      enableCorsCorrelation: true, // Enable CORS correlation for better tracking
      correlationHeaderExcludedDomains: [
        '*.datadoghq.eu',
        '*.datadoghq.com',
        'browser-intake-datadoghq.eu',
        'browser-intake-datadoghq.com',
      ],
      correlationHeaderDomains: ['*.conarc.net', '*.irispme.com'],
      enableRequestHeaderTracking: true, // Track request headers
      enableResponseHeaderTracking: true, // Track response headers
      disableFetchTracking: false, // Enable fetch request tracking
      disableAjaxTracking: false, // Enable AJAX request tracking
      autoTrackPageVisitTime: true, // Automatically track how long users spend on each page
      enableUnhandledPromiseRejectionTracking: true, // Track unhandled promise rejections
    },
  });

  // Load Application Insights
  appInsights.loadAppInsights();

  // Track the initial page view
  appInsights.trackPageView();
} else {
  console.warn('Application Insights connection string not found in AppConfig. Telemetry tracking is disabled.');
}

// Export the appInsights instance for use throughout the app
export default appInsights;

// Helper functions for common tracking scenarios
export const trackEvent = (name: string, properties?: { [key: string]: any }) => {
  if (appInsights) {
    appInsights.trackEvent({ name, properties });
  }
};

export const trackException = (exception: Error, properties?: { [key: string]: any }) => {
  if (appInsights) {
    appInsights.trackException({ exception, properties });
  }
};

export const trackMetric = (name: string, value: number, properties?: { [key: string]: any }) => {
  if (appInsights) {
    appInsights.trackMetric({ name, average: value, properties });
  }
};

export const trackTrace = (message: string, properties?: { [key: string]: any }) => {
  if (appInsights) {
    appInsights.trackTrace({ message, properties });
  }
};
